import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { IAccessRightSelectionFiltersCollection } from '@fi-shared/models';
import { isDefined } from '@fi-shared/utils';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { IFiDialogResult } from '@fi-shared/fi-dialogs/fi-dialogs';
import { Animations } from '@fi-shared/utils/animations';

@Component({
    selector: 'fi-quick-selection-section',
    templateUrl: './fi-quick-selection-section.component.html',
    styleUrl: './fi-quick-selection-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quick-selection-section' },
    standalone: false,
    animations: [Animations.fadeWidth(200)],
})
export class FiQuickSelectionSectionComponent {
    @Input() isUpdateQuickSelectionCollectionButtonVisible: boolean = false;
    @Input() isSaveAsNewQuickSelection: boolean = false;
    @Input({ required: true }) savedQuickSelectionFilters: IAccessRightSelectionFiltersCollection[] = [];
    @Input({ required: true }) selectedFiltersCollection: IAccessRightSelectionFiltersCollection;
    @Input() isMatDivierShown: boolean = true;
    @Input() quickSelectLabelId: string = 'access_rights.quick_selection';
    @Output() selectedFiltersCollectionChange = new EventEmitter<IAccessRightSelectionFiltersCollection>();
    @Output() updateQuickSelectionCollection = new EventEmitter<void>();
    @Output() deleteQuickChoiceFiltersCollection = new EventEmitter<IAccessRightSelectionFiltersCollection>();

    // Set as default feature is disabled https://chainformation.atlassian.net/browse/FI-6357?focusedCommentId=62247
    /*
    @Output() setSelectedFilterAsDefault = new EventEmitter<void>;
    */

    @Input() isNewQuickSelectionSetToDefault: boolean = false;
    @Input() newQuickSelectionFilterName: string = '';
    @Output() newQuickSelectionFilterNameChange = new EventEmitter<string>();

    @ViewChild('newQuickSelectionInput', { static: false }) protected set newQuickSelectionInput(
        value: ElementRef<HTMLInputElement>,
    ) {
        if (value) {
            value.nativeElement.focus();
        }
    }

    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
    ) {}

    // Set as default feature is disabled https://chainformation.atlassian.net/browse/FI-6357?focusedCommentId=62247
    /*isSetDefaultButtonDisabled(): boolean {
        return this.isSaveAsNewQuickSelection ?
            !this.newQuickSelectionFilterName?.length || this.isNewQuickSelectionSetToDefault :
            !isDefined(this.selectedFiltersCollection) || this.selectedFiltersCollection?.IsDefault;
    }*/

    protected updateQuickSelection(): void {
        this.updateQuickSelectionCollection.emit();
    }

    protected selectedFilterIdChange(filtersCollectionId: number): void {
        const selectedFilter: IAccessRightSelectionFiltersCollection = this.savedQuickSelectionFilters.find(
            (filter: IAccessRightSelectionFiltersCollection) => {
                return filter.Id === filtersCollectionId;
            },
        );

        this.selectedFiltersCollection = selectedFilter;
        this.selectedFiltersCollectionChange.emit(this.selectedFiltersCollection);
    }

    protected deleteQuickChoiceClick(filtersCollection: IAccessRightSelectionFiltersCollection): void {
        this.getSelectionFilterDeleteConfirmationDialog().onYesButtonClick(() =>
            this.deleteQuickChoiceFiltersCollection.emit(filtersCollection),
        );
    }

    protected editQuickChoiceClick(filtersCollection: IAccessRightSelectionFiltersCollection): void {
        this.selectedFilterIdChange(filtersCollection.Id);
    }

    /*protected setNewDefaultFilter(): void {
        this.setSelectedFilterAsDefault.emit();
    }*/

    private getSelectionFilterDeleteConfirmationDialog(): IFiDialogResult {
        return this.fiDialogsService.confirmSimpleDelete({
            headerText: this.appTextService.get('dialog.header_confirm'),
            messageText: this.appTextService.get('access_rights.delete_selection.confirm'),
            preventUppercaseButtonLabel: true,
        });
    }
}
